export default __webpack_public_path__ + "static/media/reload.1746c748.svg";